import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
    link: {
        display: 'flex',
        alignItems: 'center'
    }
}))
